// Utility functions for admin functionality

export const setTempAdminRole = () => {
  localStorage.setItem('token', 'temp-admin-token');
  localStorage.setItem('userRole', 'ADMIN');
  window.location.href = '/admin';
};

export const clearAdminRole = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userRole');
  window.location.href = '/login';
};

export const isAdmin = (): boolean => {
  const userRole = localStorage.getItem('userRole');
  return userRole === 'ADMIN';
};

export const hasPermission = (requiredRole: 'ADMIN' | 'MANAGER' | 'USER'): boolean => {
  const userRole = localStorage.getItem('userRole') as 'ADMIN' | 'MANAGER' | 'USER' | null;
  
  if (!userRole) return false;
  
  // Admin has access to everything
  if (userRole === 'ADMIN') return true;
  
  // Manager has access to manager and user level
  if (userRole === 'MANAGER' && (requiredRole === 'MANAGER' || requiredRole === 'USER')) {
    return true;
  }
  
  // User only has access to user level
  if (userRole === 'USER' && requiredRole === 'USER') {
    return true;
  }
  
  return false;
};

export const getUserDisplayName = (): string => {
  const userRole = localStorage.getItem('userRole');
  switch (userRole) {
    case 'ADMIN':
      return '관리자';
    case 'MANAGER':
      return '매니저';
    case 'USER':
      return '사용자';
    default:
      return '게스트';
  }
};